import { Path, Point } from 'slate';

export default function areSamePoints(a: Point, b: Point): boolean {
    return a.offset === b.offset && Path.equals(a.path, b.path);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('areSamePoints', async () => {
        it.todo('look for native implementation from slate');
    });
}

// #endregion
